import NiceSelect from "./../../../../../../../../node_modules/nice-select2/dist/js/nice-select2";
import copy from "copy-text-to-clipboard";

document.addEventListener("alpine:init", () => {
    let trackingSent = false;

    const formFields = document.querySelectorAll(".calculator-form2 .trigger");
    formFields.forEach((field) => {
        if (field.tagName.toLowerCase() === "input") {
            field.addEventListener("input", (event) => {
                validateForm();
                convertUnit();
            });
        } else if (field.tagName.toLowerCase() === "select") {
            field.addEventListener("change", (event) => {
                validateForm();
                convertUnit();
            });
        }
    });

    const convertUnit = () => {
        const analyte = document.querySelector(".calculator-form2 #analyte").value;
        const von = document.querySelector(".calculator-form2 #von").value;
        const vonUnit = document.querySelector(".calculator-form2 #vonUnit").value;
        const intoUnit = document.querySelector(".calculator-form2 #intoUnit").value;
        const result = document.querySelector(".calculator-form2 #resultat");
        const information = document.querySelector(".c-calculator-form__information");

        let t,
            i = analyte,
            n = {
                l: 1,
                dl: 10,
                ml: 1e3,
                g: 1,
                mg: 1e3,
                µg: Math.pow(10, 6),
                ng: Math.pow(10, 9),
                pg: Math.pow(10, 12),
                mol: 1 / i,
                mmol: (1 / i) * 1e3,
                µmol: (1 / i) * Math.pow(10, 6),
                nmol: (1 / i) * Math.pow(10, 9),
                pmol: (1 / i) * Math.pow(10, 12),
            },
            r = vonUnit,
            a = intoUnit,
            o = von,
            l = r.split("/"),
            d = a.split("/"),
            u = n[l[0]] / n[l[1]],
            c = n[d[0]] / n[d[1]] / u,
            h = Math.pow(10, 6);

        if (((o = o.replace(/,/g, ".")), isNaN(o) || isNaN(c))) result.value = "";
        else {
            t = o * c;
            var f;
            if (!isWholeNumber(t)) {
                if (getLengthBeforeDecimal(t) >= 6) f = Math.round(t);
                else if (getLength(t) > 6) {
                    var p = 6 - getLengthBeforeDecimal(t);
                    f = Math.round(t * Math.pow(10, p)) / Math.pow(10, p);
                } else f = Math.round(t * h) / h;
                t = f;
            }
            if ((isNaN(t) || !isFinite(t)) && i == 0) {
                information.classList.remove("hidden");
                result.value = "";
            } else {
                information.classList.add("hidden");
                result.value = t + " " + a;

                if (!trackingSent) {
                    trackingPush({ event: "calculator_result", calculator_name: "Einheitenumrechner" });
                    trackingSent = true;
                }
            }
        }
    };

    const validateForm = () => {
        const numbersPattern = /^[0-9]+$/;
        const requiredFields = document.querySelectorAll(".calculator-form2 .required");
        requiredFields.forEach((field) => {
            if (field.value.match(numbersPattern)) {
                field.classList.remove("border-red");
            } else {
                field.classList.add("border-red");
            }
        });
    };

    const isWholeNumber = (e) => {
        return e % 1 == 0;
    };

    const getLengthBeforeDecimal = (e) => {
        return e.toString().split(".")[0].length;
    };

    const getLength = (e) => {
        return (e + "").replace(".", "").length;
    };

    const kopierenButton = document.querySelector(".calculator-form2 .kopieren-button");
    const iconCheck = document.querySelector(".calculator-form2 .icon-check");
    const iconCopy = document.querySelector(".calculator-form2 .icon-copy");

    if (kopierenButton) {
        kopierenButton.addEventListener("click", () => {
            const resultat = kopierenButton.parentElement.querySelector("#resultat").value;
            if (resultat) {
                navigator.clipboard.writeText(resultat);
                swapIcons(iconCheck);
                setTimeout(swapIcons, 3000, iconCopy);
            }
        });
    }

    const swapIcons = (toIcon) => {
        kopierenButton.querySelector("svg").remove();
        kopierenButton.appendChild(toIcon);
        kopierenButton.querySelector("svg").classList.remove("hidden");
    };
});
